module.exports = __webpack_public_path__ + "static/img/img(48).487cab8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(48).png
// module id = cJOr
// module chunks = 1